import { getGuessStatuses } from "./statuses";
import { CONFIG } from "../constants/config";
import { Level } from "../utils/isValidLevel";

const isMobileDevice = () => {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
         (navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform));
};

export const shareStatus = async (
  guesses: string[][],
  lost: boolean,
  solutionIndex: number,
  solution: string,
  level: Level
): Promise<boolean> => {
  const levelPlayed = level === "normal" ? "" : `${level} `;
  const shareText = levelPlayed +
    "mathler " +
    (solutionIndex + 1) +
    " " +
    `${lost ? "X" : guesses.length}` +
    "/" +
    CONFIG.tries.toString() +
    "\n\n" +
    generateEmojiGrid(guesses, solution, level) +
    "\n\n" +
    "mathler.com";

  try {
    // On mobile devices, use native share if available
    if (isMobileDevice() && navigator.share) {
      await navigator.share({ text: shareText });
      return true;
    } else {
      // On desktop, always copy to clipboard
      await navigator.clipboard.writeText(shareText);
      return true;
    }
  } catch (error) {
    console.error("Failed to share:", error);
    return false;
  }
};

export const generateEmojiGrid = (
  guesses: string[][],
  solution: string,
  level: Level
) => {
  return guesses
    .map((guess) => {
      const status = getGuessStatuses(guess, solution);
      return guess
        .map((_letter, i) => {
          switch (status[i]) {
            case "correct":
              return "🟩";
            case "present":
              return level !== "killer" ? "🟨" : "⬜";
            default:
              return "⬜";
          }
        })
        .join("");
    })
    .join("\n");
};
